import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function() {
    var slider = document.querySelector('.doctor-slider.splide');
    var splide = new Splide( slider, {
        type: 'slide',
        arrows: false,
        perPage: 1,
        perMove: 1,
    });

    splide.on( 'pagination:mounted', function (data) {
        var sliderItems = slider.querySelector('.splide__list').children;
        data.items.forEach( function (item) {
            paginationLabel = sliderItems[item.page].getAttribute('data-pagination');
            item.button.textContent = String(paginationLabel);
        });
    });

    splide.mount();
});